import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@frontend/shadcn/components/ui/select';
import { DateFilterMethodValue } from '.';

export interface DateFilterMethodSelectProps {
  children: React.ReactNode;
}

export const DateFilterMethodSelect: React.FC<DateFilterMethodSelectProps> = ({ children }) => {
  return (
    <div className="p-px">
      {children}
    </div>
  );
};

export const DateFilterMethodOptions = ({
  options,
  value,
  onChange,
}: {
  options: Array<{ value: DateFilterMethodValue; label: string; description: string }>;
  value: DateFilterMethodValue;
  onChange: (value: DateFilterMethodValue) => void;
}) => {
  return (
    <Select
      value={value}
      onValueChange={(v) => onChange(v as DateFilterMethodValue)}
      disabled={options.length === 0}
    >
      <SelectTrigger className="rounded-md">
        <SelectValue placeholder="Select date filter method">
          {
            options.find((opt) => opt.value === value)?.label ??
            'Select date filter method'
          }
        </SelectValue>
      </SelectTrigger>
      <SelectContent
        position="popper"
        side="top"
        sideOffset={4}
        className="z-50 w-[var(--radix-select-trigger-width)]"
      >
        {options.length > 0 ? (
          options.map(({ value: optionValue, label, description }) => (
            <SelectItem key={optionValue} value={optionValue} textValue={label}>
              <div>
                <div>{label}</div>
                <div className="text-xs text-muted-foreground">
                  {description}
                </div>
              </div>
            </SelectItem>
          ))
        ) : (
          <SelectItem disabled value="__none__">No date filter methods found.</SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};
